import { type ComputedRef, type Ref, ref, watch } from 'vue'

import { handleOrdersFilter, normalizeOrders } from '@/lib/adapters/orders.adapter'
import { useApi } from '@/lib/helpers/api.helpers'
import { request } from '@/lib/services'
import type { Order, OrderListFilter, OrderRaw } from '@/lib/types/orders.types'
export const useGetOrders = (
  storeIdRef: ComputedRef<number | undefined>,
  filter: Ref<OrderListFilter> | ComputedRef<OrderListFilter>,
) => {
  const data = ref<Order[]>([])
  const totalPages = ref(1)
  const { loading, error, fetchOrders } = useApi({
    fetchOrders: async (storeId: number, currentFilter: OrderListFilter) => {
      const response = await request.get<{ data: OrderRaw[]; last_page?: number }>(
        `/advertiser/stores/${storeId}/orders`,
        { params: handleOrdersFilter(currentFilter) },
      )
      data.value = normalizeOrders(response.data.data)
      totalPages.value = response.data.last_page ?? 1
    },
  })
  watch(
    () => [storeIdRef.value, { ...filter.value }] as const,
    () => {
      const storeId = storeIdRef.value
      if (storeId) {
        void fetchOrders(storeId, filter.value)
      }
    },
    { immediate: true },
  )
  return { data, totalPages, isLoading: loading, error }
}

export const buildOrdersExportUrl = (storeId: number, filter: OrderListFilter): string => {
  const params = new URLSearchParams()
  const { from, to } = handleOrdersFilter(filter)
  if (from && to) {
    params.append('from', from)
    params.append('to', to)
  }
  params.append('format', 'xlsx')
  return `/advertiser/stores/${storeId}/orders?${params.toString()}`
}
